import { create } from "zustand";
import type { CreateOrganizationRequest, Organization } from "../types";

interface OrganizationsState {
	modalOpen: boolean;
	editingItem: Organization | null;
	createDefaults: Partial<CreateOrganizationRequest>;
}

interface OrganizationsActions {
	openCreateModal: (defaults?: Partial<CreateOrganizationRequest>) => void;
	openEditModal: (item: Organization) => void;
	closeModal: () => void;
}

type OrganizationsStore = OrganizationsState & OrganizationsActions;

export const useOrganizationsStore = create<OrganizationsStore>((set) => ({
	modalOpen: false,
	editingItem: null,
	createDefaults: {},

	openCreateModal: (defaults = {}) => {
		set({ modalOpen: true, editingItem: null, createDefaults: defaults });
	},

	openEditModal: (item) => {
		set({ modalOpen: true, editingItem: item, createDefaults: {} });
	},

	closeModal: () => {
		set({ modalOpen: false, editingItem: null, createDefaults: {} });
	},
}));
